import { ZustandStore } from "../../../store/zustand-store";
import { useEffect } from "react";
import axios from "axios";
import { GET_USER_HISTORY } from "../../../services/constants";

const HistoryList = () => {
  const { history_data } = ZustandStore((state) => state);

  useEffect(() => {
    const admin_mail = localStorage.getItem("admin_mail");

    const fetchData = async () => {
      try {
        const response = await axios.get(GET_USER_HISTORY(admin_mail));
        ZustandStore.setState({
          history_data: {
            data: response.data,
            error: false,
            loading: false,
          },
        });
      } catch (error) {
        ZustandStore.setState({
          history_data: {
            data: [],
            error: true,
            loading: false,
          },
        });
      }
    };

    if (history_data?.data?.length === 0 && history_data?.loading) {
      fetchData();
    }
  }, [history_data]);

  return null;
};

export default HistoryList;
